import { render, staticRenderFns } from "./PlanoPagamentoProfile.vue?vue&type=template&id=5992a814"
import script from "./PlanoPagamentoProfile.vue?vue&type=script&lang=js"
export * from "./PlanoPagamentoProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports